import * as React from 'react';

type usePrinterReturnType = {
  printers: USBDevice[];
  requestDevice: () => void;
  print: (printer: USBDevice, data: string) => void;
};

const NEW_LINE = '\x1B\x64\x02';
const CUT_PAPER = '\x1B\x69';

const usePrinter = (): usePrinterReturnType => {
  const [printers, setPrinters] = React.useState<USBDevice[]>([]);

  /**
   * Request printer permission and get list of printers
   * @returns void
   */
  const requestDevice = async () => {
    // Request A Device
    const device = await navigator.usb.requestDevice({
      filters: [],
    });

    setPrinters((prev) => [...prev, device]);
  };

  const initPrinter = async (printer: USBDevice) => {
    await printer.open();
    await printer.selectConfiguration(1);
    if (printer.configuration) {
      await printer.claimInterface(printer.configuration.interfaces[0].interfaceNumber);
    }
  };

  /**
   * Sends data to selected printer
   * @param printer Selected Printer
   * @param data Data to be sent to printer
   */
  const print = async (printer: USBDevice, data: string) => {
    const encoder = new TextEncoder();
    data += NEW_LINE + NEW_LINE + CUT_PAPER;
    const encodedData = encoder.encode(data);
    let endpoint = 1;

    for (let i = 0; i < endpoint; i++) {
      try {
        await initPrinter(printer);
        await printer.transferOut(endpoint, encodedData);
        return;
      } catch (e: any) {
        if (e.message.includes('The specified endpoint is not part of a claimed and selected alternate interface')) {
          if (endpoint < 15) {
            endpoint++;
          } else {
            console.log('failed!', e);
            return;
          }
        }
      }
    }
  };

  return { printers, requestDevice, print };
};

export { usePrinter };
